import e from "../../utils/classNames.js";
import { isSvgIcon as t, normalizeIconName as n } from "../../utils/iconNames.js";
import { useState as r } from "react";
import { jsx as i, jsxs as a } from "react/jsx-runtime";
//#region src/components/icon/Icon.tsx
var o = (o) => {
	let { className: s = "", iconName: c, icon: l, hoverIconName: u, hoverIcon: d, iconClassName: f = "", pairIconName: p, pairIcon: m, hoverPairIconName: h, hoverPairIcon: g, pairIconClassName: _ = "", size: v, spinning: y = !1, pulsing: b = !1, filled: x = !1, disabled: S = !1, disabledDanger: C = !1, disabledInverse: w = !1 } = o, [T, E] = r(!1), D = c ?? l ?? "", O = u ?? d, k = p ?? m, A = h ?? g, j = T && O ? O : D, M = O || k && A ? {
		onMouseEnter: () => E(!0),
		onMouseLeave: () => E(!1)
	} : {}, N = y ? "spinning" : "", P = b ? "pulsing" : "", F = x ? "uikit-icon-filled" : "", I = S ? "uikit-icon-disabled" : "", L = C ? "uikit-icon-disabled uikit-icon-disabled-danger" : "", R = w ? "uikit-icon-disabled uikit-icon-disabled-inverse" : "", z;
	if (t(j) && (z = { "--i": `url(${j})` }), k) {
		let r = T && A ? A : k, o = e("uikit-icon-pair", v && `text-size-${v}`, s), c = e("uikit-icon", !t(j) && n(j), f), l = e("uikit-icon", !t(r) && n(r), _, N, P), u;
		return t(r) && (u = { "--i": `url(${r})` }), /* @__PURE__ */ a("span", {
			className: o,
			...M,
			children: [/* @__PURE__ */ i("span", {
				className: c,
				style: z
			}), /* @__PURE__ */ i("span", {
				className: l,
				style: u
			})]
		});
	}
	let B = e("uikit-icon", !t(j) && n(j), v && `text-size-${v}`, I, L, R, s, f, N, P, F);
	return /* @__PURE__ */ i("span", {
		className: B,
		style: z,
		...M
	});
};
//#endregion
export { o as default, n as normalizeIconName };

//# sourceMappingURL=Icon.js.map